/**
 * Mulberry32 PRNG generator factory.
 *
 * @param {number} a - 32-bit integer seed (internal state). Passing the same seed
 *                     produces the same sequence.
 * @returns {() => number} - zero-argument function that returns a pseudorandom
 *                           float in the range [0, 1). (Max = 1 - 2^-32)
 *
 * Usage:
 *   const rnd = mulberry32(12345);
 *   const u = rnd(); // 0 <= u < 1
 *
 * Notes:
 * - Fast, small-state; not cryptographically secure.
 * - Each call updates the internal 32-bit state.
 */
export function mulberry32(a: number): () => number {
  return function () {
    let t = (a += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
